import { morphism, StrictSchema } from 'morphism'

import ClientPassengerFormValueInterface from '../../interfaces/client/PassengerFormValue'
import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ClientInfantPassengerInterface from '../../interfaces/client/InfantPassenger'
import ClientInfantPassengerFormValueInterface from '../../interfaces/client/InfantPassengerFormValue'

import store from '../../store'

import staticData from '../../config/staticData'

import infantPassengerFormValueToInfantPassenger from './infantPassengerFormValueToInfantPassenger'

export const travelClass = (
  passengerFormValue: ClientPassengerFormValueInterface
) =>
  passengerFormValue['travel-class']
    ? passengerFormValue['travel-class']
    : staticData.defaultTravelClass

const getSSR = (SSRId: string) => store.getState().ssrs.byId[SSRId]

export const SSRs = (passengerFormValue: ClientPassengerFormValueInterface) => {
  if (!passengerFormValue.ssrs) return []

  const SSRIds = passengerFormValue.ssrs.split(',')

  return SSRIds.map((SSRId: string) => getSSR(SSRId))
}

export const infant = (
  passengerFormValue: ClientPassengerFormValueInterface
) => {
  if (!passengerFormValue.infant) return undefined

  return morphism<
    StrictSchema<
      ClientInfantPassengerInterface,
      ClientInfantPassengerFormValueInterface
    >
  >(infantPassengerFormValueToInfantPassenger, passengerFormValue.infant)
}

export const checkedInOnFlights = ({
  id,
}: ClientPassengerFormValueInterface) => {
  const passengerFromStore: ClientPassengerInterface = store.getState()
    .passengers.byId[id]

  return passengerFromStore ? passengerFromStore.checkedInOnFlights : []
}

export default {
  id: 'id',
  thirdPartyBookingNumber: 'booking-id',
  dateOfBirth: 'date-of-birth',
  firstName: 'first-name',
  lastName: 'last-name',
  gender: 'gender',
  luggage: 'luggage',
  travelClass,
  ssrs: SSRs,
  infant,
  flightId: 'flightId',
  checkedInOnFlights,
}
